import { render, staticRenderFns } from "./onDialogBeforeClose-editor.vue?vue&type=template&id=2f891674&scoped=true&"
import script from "./onDialogBeforeClose-editor.vue?vue&type=script&lang=js&"
export * from "./onDialogBeforeClose-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f891674",
  null
  
)

export default component.exports